export const ProjectData = [
  {
    id: "1",
    title: "EduAdminHub - School Management System",
    bannerImage: "/assets/img/blog/blog-1.jpg",
    category: "Education Technology",
    status: "completed",
    technologies: ["React.js", "Node.js", "MongoDB", "Express.js"],
    description:
      "A comprehensive cloud-based school management platform designed to streamline every aspect of educational institution operations. From student admissions and attendance tracking to fee management and parent communication, EduAdminHub simplifies school administration.",
    subTitle: "Transforming Education Management",
    subDescription:
      "EduAdminHub provides a unified platform for schools and colleges to manage their daily operations efficiently. The system includes role-based dashboards for administrators, teachers, students, and parents, ensuring everyone has access to the information they need.",
    galleryImages: [
      "/assets/img/blog/comments-1.jpg",
      "/assets/img/blog/blog-recent-3.jpg",
      "/assets/img/blog/blog-recent-2.jpg",
    ],
    resultTitle: "Project Results & Impact",
    resultParagraphs: [
      "The implementation of EduAdminHub resulted in significant improvements in operational efficiency. Schools reported a 75% reduction in administrative workload, allowing staff to focus more on teaching and student engagement.",
      "The platform successfully manages over 500+ schools with 2M+ students, demonstrating its scalability and reliability. Real-time communication features improved parent-school engagement by 85%, leading to better student outcomes.",
      "Key achievements include automated fee management reducing payment delays by 60%, streamlined attendance tracking saving 10+ hours per week, and comprehensive reporting enabling data-driven decision making.",
    ],
    stats: [
      { label: "Schools", value: "500+" },
      { label: "Students", value: "2M+" },
      { label: "Time Saved", value: "75%" },
      { label: "Satisfaction", value: "98%" },
    ],
    info: {
      description: "Enterprise-grade school management platform for modern educational institutions.",
      client: "Educational Institutions",
      date: "January 15, 2024",
      website: "https://eduadminhub.com",
      location: "India",
      duration: "12 months",
      team: "15 members",
    },
    testimonial: {
      quote:
        "EduAdminHub has revolutionized how we manage our school. The efficiency gains are remarkable!",
      author: "Principal, ABC International School",
    },
  },
  {
    id: "2",
    title: "Enterprise HRM Platform",
    bannerImage: "/assets/img/blog/blog-2.jpg",
    category: "Human Resources",
    status: "completed",
    technologies: ["React.js", "Node.js", "PostgreSQL", "AWS"],
    description:
      "A comprehensive Human Resource Management system designed for educational institutions. The platform handles staff records, attendance tracking, payroll processing, leave management, and performance evaluations all in one integrated solution.",
    subTitle: "Streamlining HR Operations",
    subDescription:
      "Our HRM platform eliminates manual paperwork and provides automated workflows for all HR processes. Features include biometric attendance integration, automated payroll calculations, and comprehensive reporting dashboards.",
    galleryImages: [
      "/assets/img/blog/blog-recent-2.jpg",
      "/assets/img/blog/blog-recent-3.jpg",
      "/assets/img/blog/comments-2.jpg",
    ],
    resultTitle: "Results & Benefits",
    resultParagraphs: [
      "The HRM platform reduced HR administrative time by 70%, allowing HR teams to focus on strategic initiatives. Payroll processing time decreased from 5 days to 2 hours, significantly improving staff satisfaction.",
      "Automated attendance tracking eliminated manual errors and provided real-time insights. The system processes payroll for 50K+ employees across 300+ institutions with 99.9% accuracy.",
      "Employee self-service portal reduced HR inquiries by 60%, while comprehensive analytics helped management make informed decisions about workforce planning and resource allocation.",
    ],
    stats: [
      { label: "Institutions", value: "300+" },
      { label: "Employees", value: "50K+" },
      { label: "Time Saved", value: "70%" },
      { label: "Accuracy", value: "99.9%" },
    ],
    info: {
      description: "Enterprise HRM solution for educational institutions and organizations.",
      client: "Educational & Corporate Organizations",
      date: "March 20, 2024",
      website: "https://hrm.oethical.com",
      location: "India",
      duration: "10 months",
      team: "12 members",
    },
    testimonial: {
      quote:
        "The HRM platform has transformed our HR operations. Payroll processing is now effortless!",
      author: "HR Manager, XYZ University",
    },
  },
  {
    id: "3",
    title: "Library Management System (LMS)",
    bannerImage: "/assets/img/blog/blog-3.jpg",
    category: "Library Management",
    status: "completed",
    technologies: ["React.js", "MongoDB", "Node.js", "Cloud Storage"],
    description:
      "A modern library management system that digitizes all library operations including cataloging, member management, book issuing, returns, and automated notifications. The platform supports both physical and digital library resources.",
    subTitle: "Digital Library Transformation",
    subDescription:
      "Our LMS platform enables libraries to manage their entire collection digitally. Features include barcode scanning, automated fine calculations, online reservations, and comprehensive reporting for better resource management.",
    galleryImages: [
      "/assets/img/blog/blog-recent-5.jpg",
      "/assets/img/blog/blog-recent-1.jpg",
      "/assets/img/blog/comments-3.jpg",
    ],
    resultTitle: "Impact & Achievements",
    resultParagraphs: [
      "The library management system streamlined operations across 200+ libraries, managing over 1M+ books. Checkout processes became 80% faster, significantly improving member experience.",
      "Automated notifications reduced overdue books by 65%, and digital cataloging made resource discovery 10x easier. Real-time availability tracking improved resource utilization by 40%.",
      "The platform's mobile app enables members to browse catalogs, reserve books, and check their account status from anywhere, leading to increased engagement and satisfaction.",
    ],
    stats: [
      { label: "Libraries", value: "200+" },
      { label: "Books Managed", value: "1M+" },
      { label: "Process Speed", value: "80% Faster" },
      { label: "User Satisfaction", value: "95%" },
    ],
    info: {
      description: "Comprehensive library management solution for modern libraries.",
      client: "Academic & Public Libraries",
      date: "May 10, 2024",
      website: "https://lms.oethical.com",
      location: "India",
      duration: "8 months",
      team: "10 members",
    },
    testimonial: {
      quote:
        "LMS has made our library operations so much smoother. Members love the convenience!",
      author: "Chief Librarian, ABC College",
    },
  },
  {
    id: "4",
    title: "E-Commerce Platform Development",
    bannerImage: "/assets/img/blog/blog-4.jpg",
    category: "E-Commerce",
    status: "completed",
    technologies: ["React.js", "Next.js", "Node.js", "Stripe", "MongoDB"],
    description:
      "A full-featured e-commerce platform with advanced features including product catalog, shopping cart, payment integration, order management, and customer analytics. The platform supports multiple payment gateways and shipping providers.",
    subTitle: "Modern E-Commerce Solution",
    subDescription:
      "Built with performance and user experience in mind, this e-commerce platform handles high traffic volumes and provides seamless shopping experiences. Features include personalized recommendations, inventory management, and comprehensive admin dashboard.",
    galleryImages: [
      "/assets/img/blog/blog-recent-4.jpg",
      "/assets/img/blog/comments-4.jpg",
      "/assets/img/blog/blog-recent-2.jpg",
    ],
    resultTitle: "Business Impact",
    resultParagraphs: [
      "The e-commerce platform increased client's online sales by 300% within the first 6 months. Improved checkout process reduced cart abandonment by 45%, and mobile-optimized design captured 60% of sales from mobile devices.",
      "Advanced analytics provided valuable insights into customer behavior, enabling data-driven marketing strategies. The platform processes thousands of orders daily with 99.9% uptime.",
      "Integration with multiple payment gateways and shipping providers streamlined operations, while automated inventory management eliminated stockout situations.",
    ],
    stats: [
      { label: "Sales Increase", value: "300%" },
      { label: "Cart Abandonment", value: "-45%" },
      { label: "Mobile Sales", value: "60%" },
      { label: "Uptime", value: "99.9%" },
    ],
    info: {
      description: "Enterprise e-commerce platform with advanced features and analytics.",
      client: "RetailPro Inc.",
      date: "August 15, 2024",
      website: "https://retailpro.com",
      location: "USA",
      duration: "14 months",
      team: "18 members",
    },
    testimonial: {
      quote:
        "Our sales have tripled since launching this platform. The user experience is exceptional!",
      author: "CEO, RetailPro Inc.",
    },
  },
  {
    id: "5",
    title: "Cloud Migration & Infrastructure",
    bannerImage: "/assets/img/blog/blog-5.jpg",
    category: "Cloud Services",
    status: "completed",
    technologies: ["AWS", "Docker", "Kubernetes", "CI/CD", "Terraform"],
    description:
      "A comprehensive cloud migration project that moved legacy infrastructure to modern cloud architecture. The solution includes containerization, automated scaling, and disaster recovery capabilities.",
    subTitle: "Modern Cloud Infrastructure",
    subDescription:
      "Migrated enterprise applications to AWS with containerization using Docker and Kubernetes. Implemented CI/CD pipelines for automated deployments and configured auto-scaling for optimal performance and cost efficiency.",
    galleryImages: [
      "/assets/img/blog/blog-recent-1.jpg",
      "/assets/img/blog/comments-5.jpg",
      "/assets/img/blog/blog-recent-3.jpg",
    ],
    resultTitle: "Infrastructure Improvements",
    resultParagraphs: [
      "Cloud migration reduced infrastructure costs by 40% while improving performance and scalability. Application deployment time decreased from days to minutes with automated CI/CD pipelines.",
      "The new infrastructure handles 10x traffic spikes automatically, ensuring seamless user experience. Disaster recovery capabilities reduced RTO from 24 hours to 15 minutes.",
      "Enhanced security with cloud-native security features, automated backups, and compliance with industry standards. The infrastructure now supports 99.99% uptime with global CDN integration.",
    ],
    stats: [
      { label: "Cost Reduction", value: "40%" },
      { label: "Deployment Time", value: "-95%" },
      { label: "Scalability", value: "10x" },
      { label: "Uptime", value: "99.99%" },
    ],
    info: {
      description: "Enterprise cloud migration and infrastructure modernization.",
      client: "Fortune 500 Company",
      date: "October 20, 2024",
      website: "https://example.com",
      location: "Global",
      duration: "16 months",
      team: "25 members",
    },
    testimonial: {
      quote:
        "The cloud migration exceeded our expectations. Performance and cost savings are remarkable!",
      author: "CTO, Fortune 500 Company",
    },
  },
  {
    id: "6",
    title: "Mobile Banking Application",
    bannerImage: "/assets/img/blog/blog-6.jpg",
    category: "FinTech",
    status: "completed",
    technologies: ["React Native", "Node.js", "PostgreSQL", "Biometric Auth"],
    description:
      "A secure mobile banking application with features including account management, fund transfers, bill payments, investment tracking, and biometric authentication. Built with security and user experience as top priorities.",
    subTitle: "Secure Mobile Banking",
    subDescription:
      "The mobile banking app provides a seamless banking experience with advanced security features. Includes real-time transaction updates, spending analytics, card management, and support for multiple accounts.",
    galleryImages: [
      "/assets/img/blog/comments-6.jpg",
      "/assets/img/blog/blog-recent-5.jpg",
      "/assets/img/blog/blog-recent-4.jpg",
    ],
    resultTitle: "User Engagement & Security",
    resultParagraphs: [
      "The mobile banking app achieved 500K+ downloads within 6 months with a 4.8-star rating. Daily active users increased by 200%, and transaction volume grew by 350% compared to previous banking solutions.",
      "Biometric authentication and advanced security measures resulted in zero security breaches. Real-time fraud detection prevented unauthorized transactions worth millions.",
      "User-friendly interface and personalized features led to 85% user retention rate. Spending analytics helped users manage finances better, resulting in increased engagement.",
    ],
    stats: [
      { label: "Downloads", value: "500K+" },
      { label: "User Rating", value: "4.8/5" },
      { label: "DAU Increase", value: "200%" },
      { label: "Security", value: "100%" },
    ],
    info: {
      description: "Secure and feature-rich mobile banking application.",
      client: "National Bank",
      date: "November 30, 2024",
      website: "https://bankapp.com",
      location: "India",
      duration: "18 months",
      team: "20 members",
    },
    testimonial: {
      quote:
        "Our mobile banking app has revolutionized customer experience. Security and usability are excellent!",
      author: "Head of Digital Banking, National Bank",
    },
  },
  {
    id: "7",
    title: "AI-Powered Analytics Platform",
    bannerImage: "/assets/img/blog/blog-1.jpg",
    category: "AI & Analytics",
    status: "upcoming",
    technologies: ["Python", "TensorFlow", "React.js", "Kafka", "Elasticsearch"],
    description:
      "An advanced AI-powered analytics platform that provides predictive insights, automated reporting, and intelligent data visualization. The platform uses machine learning algorithms to identify patterns and trends in business data.",
    subTitle: "Intelligent Data Analytics",
    subDescription:
      "This upcoming project will leverage artificial intelligence and machine learning to transform raw data into actionable insights. Features include predictive analytics, anomaly detection, natural language processing, and automated report generation.",
    galleryImages: [
      "/assets/img/blog/blog-recent-2.jpg",
      "/assets/img/blog/blog-recent-3.jpg",
    ],
    resultTitle: "Expected Outcomes",
    resultParagraphs: [
      "The AI-powered analytics platform is expected to provide real-time insights, reducing decision-making time by 80%. Predictive analytics will help businesses anticipate trends and make proactive decisions.",
      "Automated reporting will save hundreds of hours monthly, while intelligent anomaly detection will identify issues before they impact operations. Natural language query interface will make data accessible to non-technical users.",
      "The platform will support multiple data sources and provide unified analytics dashboards. Advanced visualization capabilities will help stakeholders understand complex data patterns easily.",
    ],
    stats: [
      { label: "Data Sources", value: "50+" },
      { label: "Insight Speed", value: "Real-time" },
      { label: "Time Saved", value: "80%" },
      { label: "Accuracy", value: "95%+" },
    ],
    info: {
      description: "Next-generation AI-powered analytics and insights platform.",
      client: "Enterprise Clients",
      date: "Q1 2025",
      website: "Coming Soon",
      location: "Global",
      duration: "20 months",
      team: "30 members",
    },
    testimonial: null,
  },
  {
    id: "8",
    title: "IoT Smart Campus Solution",
    bannerImage: "/assets/img/blog/blog-2.jpg",
    category: "IoT",
    status: "upcoming",
    technologies: ["IoT Sensors", "Edge Computing", "React.js", "MQTT", "Cloud"],
    description:
      "A comprehensive IoT solution for smart campuses that integrates various sensors and devices for automated monitoring, energy management, security, and facility optimization. The platform provides real-time data and intelligent automation.",
    subTitle: "Connected Campus Ecosystem",
    subDescription:
      "This upcoming IoT solution will connect various campus systems including lighting, HVAC, security cameras, parking systems, and energy meters. AI-powered analytics will optimize resource usage and enhance campus safety.",
    galleryImages: [
      "/assets/img/blog/blog-recent-4.jpg",
      "/assets/img/blog/blog-recent-5.jpg",
    ],
    resultTitle: "Expected Benefits",
    resultParagraphs: [
      "The IoT smart campus solution is expected to reduce energy consumption by 35% through intelligent automation and monitoring. Real-time alerts and automated responses will improve campus safety and security.",
      "Predictive maintenance capabilities will reduce equipment downtime by 50%, while data-driven insights will help optimize space utilization and resource allocation. Integration with existing systems will provide unified control.",
      "The platform will support thousands of IoT devices and provide comprehensive dashboards for facility managers. Mobile app integration will allow remote monitoring and control of campus systems.",
    ],
    stats: [
      { label: "Energy Savings", value: "35%" },
      { label: "Devices Supported", value: "10K+" },
      { label: "Downtime Reduction", value: "50%" },
      { label: "Response Time", value: "<1 sec" },
    ],
    info: {
      description: "Comprehensive IoT solution for smart campus management.",
      client: "Educational Institutions",
      date: "Q2 2025",
      website: "Coming Soon",
      location: "India",
      duration: "24 months",
      team: "35 members",
    },
    testimonial: null,
  },
  {
    id: "9",
    title: "EduAdminHub Mobile Application",
    bannerImage: "/assets/img/blog/blog-3.jpg",
    category: "Education Technology",
    status: "upcoming",
    technologies: ["React Native", "Node.js", "MongoDB", "Push Notifications", "Offline Sync"],
    description:
      "A comprehensive mobile application for EduAdminHub that brings all school management features to iOS and Android devices. The app will enable students, parents, teachers, and administrators to access the platform on-the-go with full functionality.",
    subTitle: "Education Management on Mobile",
    subDescription:
      "The EduAdminHub mobile app will provide seamless access to attendance, assignments, grades, fee payments, announcements, and more. Features include offline mode, push notifications, biometric authentication, and real-time synchronization with the web platform.",
    galleryImages: [
      "/assets/img/blog/blog-recent-1.jpg",
      "/assets/img/blog/blog-recent-2.jpg",
      "/assets/img/blog/blog-recent-3.jpg",
    ],
    resultTitle: "Expected Features & Benefits",
    resultParagraphs: [
      "The mobile app will provide 24/7 access to school information, enabling parents to track their child's progress, view attendance, and make fee payments anytime, anywhere. Students can access assignments, timetables, and study materials on their mobile devices.",
      "Push notifications will ensure instant updates about important announcements, exam schedules, and attendance alerts. Offline mode will allow users to access cached data even without internet connectivity, with automatic sync when connection is restored.",
      "Biometric authentication and secure login will ensure data security, while the intuitive mobile interface will improve user engagement. The app will support multiple languages and be optimized for both iOS and Android platforms.",
      "Expected to increase parent engagement by 90%, reduce communication gaps, and provide a seamless experience across all devices. The mobile app will complement the web platform and enhance the overall EduAdminHub ecosystem.",
    ],
    stats: [
      { label: "Platforms", value: "iOS & Android" },
      { label: "Offline Mode", value: "Yes" },
      { label: "Push Notifications", value: "Real-time" },
      { label: "User Engagement", value: "+90%" },
    ],
    info: {
      description: "Native mobile application for EduAdminHub platform - iOS and Android.",
      client: "EduAdminHub Users",
      date: "Q1 2025",
      website: "Coming Soon",
      location: "Global",
      duration: "8 months",
      team: "12 members",
    },
    testimonial: null,
  },
  {
    id: "10",
    title: "EduAdminHub Exam Portal",
    bannerImage: "/assets/img/blog/blog-4.jpg",
    category: "Education Technology",
    status: "upcoming",
    technologies: ["React.js", "Node.js", "MongoDB", "AI Proctoring", "Real-time Analytics"],
    description:
      "An advanced online examination portal integrated with EduAdminHub that enables schools to conduct secure, automated online exams. The portal includes AI-powered proctoring, automated grading, question bank management, and comprehensive result analytics.",
    subTitle: "Secure Online Examination System",
    subDescription:
      "The Exam Portal will support multiple question types including MCQs, descriptive answers, file uploads, and coding assessments. Features include AI-based proctoring to prevent cheating, automated result generation, detailed analytics, and seamless integration with EduAdminHub's student management system.",
    galleryImages: [
      "/assets/img/blog/blog-recent-4.jpg",
      "/assets/img/blog/blog-recent-5.jpg",
      "/assets/img/blog/comments-1.jpg",
    ],
    resultTitle: "Expected Capabilities & Impact",
    resultParagraphs: [
      "The Exam Portal will streamline the entire examination process, from question paper creation to result publication. Teachers can create question banks, schedule exams, and generate results automatically, saving 80% of the time spent on manual exam management.",
      "AI-powered proctoring will monitor student behavior during exams, detecting suspicious activities and ensuring exam integrity. Features include face detection, screen monitoring, tab switching alerts, and automated flagging of potential violations.",
      "Automated grading for objective questions will provide instant results, while descriptive answers can be graded online with rubrics. Comprehensive analytics will provide insights into student performance, question difficulty analysis, and class-wise statistics.",
      "The portal will support various exam types including unit tests, mid-term exams, final exams, and competitive exams. Integration with EduAdminHub will automatically update student records and generate report cards. Expected to reduce exam administration time by 75% and improve result accuracy.",
    ],
    stats: [
      { label: "Question Types", value: "10+" },
      { label: "Time Saved", value: "80%" },
      { label: "AI Proctoring", value: "Yes" },
      { label: "Auto Grading", value: "Instant" },
    ],
    info: {
      description: "Comprehensive online examination portal with AI proctoring for EduAdminHub.",
      client: "Educational Institutions",
      date: "Q2 2025",
      website: "Coming Soon",
      location: "Global",
      duration: "10 months",
      team: "15 members",
    },
    testimonial: null,
  },
];
